module.exports = {
  api: {
    API_URL_LOCAL: "http://192.168.0.202:3001",
    API_URL: // "https://painel.evomap.com.br/api"
"https://jotapix.app.br",
//"http://192.168.0.161:3001",
  },
};
